import React from 'react';
import { useGetProjectsQuery } from '../../features/projects/projectsApi';
import ProjectSingle from './ProjectSingle';

const ProjectSideBar = () => {
    const { data: projects, isLoading, isError, error } = useGetProjectsQuery()
    // decide what to render
    let content = null;

    if (isLoading) {
        content = <li className="m-2 text-center">Loading...</li>;
    } else if (!isLoading && isError) {
        content = (
            <div >Error something is wrong</div>
        );
    } else if (!isLoading && !isError && projects?.length === 0) {
        content = <div className="m-2 text-center">No projects found!</div>;
    } else if (!isLoading && !isError && projects?.length > 0) {
        content = projects?.map(single => <ProjectSingle key={single.id} {...single}></ProjectSingle>)
    }
    return (
        <div>
            <h3 className="text-xl font-bold">Projects</h3>
            <div className="mt-3 space-y-4">
                {content}
            </div>
        </div>
    );
};

export default ProjectSideBar;